import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import MessagePanel from "components/library/MessagePanel";

import styles from "./TakeoverPanel.css";

export default function TakeoverPanel({ children, containerStyle }) {
  return (
    <div className={styles.root}>
      <MessagePanel />
      <div className={classNames(styles.container, containerStyle)}>
        {children}
      </div>
    </div>
  );
}

TakeoverPanel.propTypes = {
  children: PropTypes.node.isRequired,
  containerStyle: PropTypes.string,
};
